import Vue from 'vue';
import Vuex from 'vuex';
import * as API from '@/api';
import { startSession } from '@/session';
Vue.use(Vuex);

const state = {
  userId: null
};

const actions = {
  getUserId: async (context) => {
    const userId = await API.getUserId();
    try {
      // console.log(userId);
      context.commit('setUserId', userId.data);
      startSession(userId.data)
    } catch (error) {
      throw error;
    }

    return userId.data;
  },
  removeSessionData: async (context) => {
    context.commit('polls/removePolls', null, { root: true });
    context.commit('answers/removeAnswers', null, { root: true });
  },
  deleteUser: async (context) => {
    if (state.userId) {
      // console.log(23, context.state.userId);
      await API.deleteUser(context.state.userId);
      context.commit('setUserId', null);
    }
  }
}

const mutations = {
  setUserId (state, payload) {
    state.userId = payload;
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
};
